










import { defineComponent } from '@vue/composition-api';

import { toCommaFormat } from '@/utils';

const HorizontalStackedChart = defineComponent({
  props: {
    data: {
      default: {
        labels: [],
        datasets: [] as any,
      },
    },
    xAxisLabel: { default: '' },
    yAxisLabel: { default: 'จำนวนวัน' },
    height: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const options = {
      indexAxis: 'y',
      scales: {
        // x: {
        //   title: {
        //     display: true,
        //     text: props.xAxisLabel,
        //   },
        //   ticks: {
        //     callback: (value: number) => `${toCommaFormat(value, 0, 0)}`,
        //   },
        // },
        // y: {
        //   display: true,
        //   title: {
        //     display: true,
        //     text: 'props.yAxisLabel',
        //     padding: {
        //       bottom: 20,
        //     },
        //   },
        //   ticks: {
        //     maxRotation: 0,
        //     minRotation: 0,
        //   },
        // },
        y: {
          display: true,
          ticks: {
            maxRotation: 0,
            minRotation: 0,
          },
        },
        y2: {
          display: true,
          position: 'right',
          ticks: {
            // eslint-disable-next-line
            callback: (value: number, index: number) => {
              const ftlArray: any = props.data.datasets[0].data;
              const ltlArray: any = props.data.datasets[1].data;
              const total = ftlArray.reduce((a: any, b: any) => a + b, 0) + ltlArray.reduce((a: any, b: any) => a + b, 0);
              return `${toCommaFormat(((ftlArray[index] + (ltlArray[index] ? ltlArray[index] : 0)) * 100) / total, 2, 2)} %`;
            },
          },
        },
      },
      plugins: {
        // datalabels: {
        //   anchor: 'end',
        //   align: 'top',
        //   formatter: (value, context) => {
        //     console.log(props.data.datasets);
        //   },
        // },
        legend: {
          position: 'bottom',
          align: 'start',
          labels: {
            boxWidth: 20,
          },
        },
      },
    };

    return {
      options,
    };
  },
});

export default HorizontalStackedChart;
